export const LIST_PROFESSION_SUMMARY_REQUEST = 'LIST_PROFESSION_SUMMARY_REQUEST'
export const LIST_PROFESSION_SUMMARY_SUCCESS = 'LIST_PROFESSION_SUMMARY_SUCCESS'
export const LIST_PROFESSION_SUMMARY_FAIL = 'LIST_PROFESSION_SUMMARY_FAIL'
